/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import events from '../../../app/events';
import { trackEvent } from '../../../helpers/common';
import images from '../../../images';
import { __ } from '../../../locales';
import RecycleRIGHT from '../../RecycleRIGHT';

const Container = styled.div`
  background-color: white;
  padding: 15px 0px;
  position: relative;
`;

const Title = styled.h2`
  font-size: 34px;
  font-weight: 700;
  line-height: 41px;
  font: SF UI Display;
`;

const StartButton = styled.button`
  background-color: ${process.env.REACT_APP_COLOR_RC_ROYAL};
  box-shadow: 0px 3px 6px rgba(0, 35, 145, 0.4);
  color: white;
  border-radius: 8px;
  margin: 15px 0;
`;

const RecycleRightImage = styled.img`
  display: flex;
  justify-content: center;
  width: 60%;
  margin-left: 20%;
  margin-top: 8%;
  margin-bottom: 8%;
  max-width: 90%;
  max-height: 90%;
`;

const RecycleRightLanding = styled.p`
  font-size: 15px;
  font: SF UI Text;
  font-weight: 500;
  color: ${process.env.REACT_APP_COLOR_RC_DARK_GRAY};
`;

const RecycleRIGHTGame = ({ rrGameOnly, recycleRight }) => {
  const history = useHistory();
  const [startGame, setStartGame] = useState();

  const navigateToRecycleRIGHT = () => {
    if (rrGameOnly) {
      setStartGame(true);
    } else {
      history.push('/recycle-right');
    }

    // track event
    trackEvent(events.DZ_HOME_RR_BTN_TAP);
  };
  const checkEdgeCaseRecycleRIGHT = () => {
    let hasNullMaterial = false;
    let redundantMatId = false;
    let hasNotRequiredKey = false;
    let notStandardlevelKey = false;
    const recycleRightData = recycleRight.allRrData;

    /**
     * Edge Case 1:
     * If recycleRIGHT does not exist in Discovery Zone data
     */
    if (!recycleRightData) return false;
    /**
     * Edge Case 2:
     * If recycleRIGHT is empty
     */
    if (Object.keys(recycleRightData).length === 0) return false;
    /**
     * Edge Case 3:
     * If a level key name is not standard
     */
    Object.keys(recycleRightData).forEach((level, index) => {
      if (level !== `level_${index + 1}_materials`) {
        notStandardlevelKey = true;
      }
    });

    if (notStandardlevelKey) return false;

    /**
     * Edge Case 4:
     * If a level does not have any material
     */
    Object.keys(recycleRightData).forEach((level) => {
      if (recycleRightData[level].length === 0) hasNullMaterial = true;
    });

    if (hasNullMaterial) return false;

    /**
     * Edge Case 5:
     * If a mat_id was redundant in recycleRIGHT
     */
    const all_mat_id = [];
    Object.keys(recycleRightData).forEach((key) => {
      recycleRightData[key].forEach((element) => {
        if (all_mat_id.indexOf(element.mat_id) !== -1) {
          redundantMatId = true;
        } else {
          all_mat_id.push(element.mat_id);
        }
      });
    });

    if (redundantMatId) return false;

    /**
     *
     * Edge Case 6:
     * If a material does not have all the required keys or one of the keys value is null
     */
    const materialKeys = ['disposal_body', 'disposal_header', 'is_recyclable', 'mat_id', 'mat_image', 'mat_nm', 'oidx'];

    Object.keys(recycleRightData).forEach((key) => {
      recycleRightData[key].forEach((material) => {
        materialKeys.forEach((requiredKey) => {
          if (!(requiredKey in material) || material[requiredKey] === null) {
            hasNotRequiredKey = true;
          }
        });
      });
    });

    if (hasNotRequiredKey) return false;

    return true;
  };

  if (!checkEdgeCaseRecycleRIGHT()) {
    return (
      <h1 style={{ margin: '80px 15px 15px 15px' }}>
        Something went wrong!
      </h1>
    );
  }
  return (
    <>
      {startGame ? <RecycleRIGHT /> : (
        <div style={{ margin: rrGameOnly ? '60px 15px 15px 15px' : '0' }}>
          <Title>
            {__('app.recycle_right')}
          </Title>
          <Container>
            <RecycleRightLanding>
              {__('app.recycle_right_landing')}
            </RecycleRightLanding>
            <RecycleRightImage
              src={images.recycle_right}
              alt="Recycle Right Phone"
            />
            <StartButton onClick={navigateToRecycleRIGHT}>
              {__('app.start')}
            </StartButton>
          </Container>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  rrGameOnly: state.app.rrGameOnly,
  recycleRight: state.recycleRight
});

export default connect(mapStateToProps, null)(RecycleRIGHTGame);
